// The checks and wording of the forgotten-password pages. Pure, so they can be tested without a screen.

export const MIN_PASSWORD_LENGTH = 6;

// What is wrong with the two password fields, or null when they are fine. (The server checks again; this is so the person is told at once.)
export function passwordProblem(password: string, confirmation: string): string | null {
    if (password.length < MIN_PASSWORD_LENGTH) return `Password must be at least ${MIN_PASSWORD_LENGTH} characters long`;
    if (password.length > 200) return 'Password must be at most 200 characters long';
    if (password !== confirmation) return 'The two passwords are not the same';

    return null;
}

// The token in a reset link's address (?token=...), or '' when there is none.
export const tokenFromSearch = (search: string) => new URLSearchParams(search).get('token') ?? '';

export const looksLikeEmail = (email: string) => /\S+@\S+\.\S+/.test(email.trim());
